import { AxiosPublic } from "../config/axios";

export async function getCategorys(query) {
  return await AxiosPublic.get("category", { params: { ...query } })
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
export async function getOneCategory(id, query) {
  return await AxiosPublic.get("category/show/" + id, { params: { ...query } })
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}
